import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";
import Modal from "@/components/modal/Modal";
import { literals } from "@/constants/literals";

export interface ConfirmEditionDetailsProps {
  onClose: () => void;
  saveChanges: () => void;
  opened: boolean;
  totalImagesAffected: number;
}

const ConfirmEditionDetails = ({
  onClose,
  totalImagesAffected,
  opened,
  saveChanges,
}: ConfirmEditionDetailsProps) => {
  return (
    <Modal title={literals.saveChanges} opened={opened} onClose={onClose}>
      <div className="w-full grid gap-4">
        <div>
          {/* Message 1: image group */}
          <p
            data-testid="modal-text"
            className="text-sm text-ib-pt-color-gray-1000"
          >
            {totalImagesAffected === 1 ? (
              literals.onePictureChanges
            ) : (
              <>
                <span>{literals.severalPictureChanges1}</span>
                <span className="font-ib-bold">{totalImagesAffected}</span>
                <span className="font-ib-bold">
                  {literals.severalPictureChanges2}
                </span>
                <span>{literals.severalPictureChanges3}</span>
              </>
            )}
          </p>
        </div>
        <PrimaryButton
          colour="red"
          icon="checkUnderline"
          label={literals.confirmAndExit}
          onClick={saveChanges}
        />
        <SecondaryButton
          colour="red"
          label={literals.cancel}
          onClick={onClose}
        />
      </div>
    </Modal>
  );
};

export default ConfirmEditionDetails;
